// extracted by mini-css-extract-plugin
export default {"tMargin":"ImageMarker_tMargin__zKCdK","boundaryHeader":"ImageMarker_boundaryHeader__MfYxe","imageToDisplay":"ImageMarker_imageToDisplay__de-LJ"};